import { ActiveConfiguration } from './ActiveConfiguration';
import { MosquitoConfiguration } from './MosquitoConfiguration';
import { PriceSegment, DiscountGroups, PricePart } from '@icc/price/b2b';
import { ConfiguratorsDataService } from '../configurators/configurators-data.service';
import { MosquitoNetType } from '../data-types/Mosquito';
import { IccColor } from '../data-types';

export class MosquitoActiveConfiguration implements ActiveConfiguration {

    constructor(configuration?, private configuratorsDataService?: ConfiguratorsDataService) {
        if (configuration) {
            if (MosquitoActiveConfiguration.is(configuration)) {
                for (const propName in configuration) {
                    if (this.hasOwnProperty(propName)) {
                        this[propName] = configuration[propName];
                    }
                }
            } else {
                if (MosquitoConfiguration.is(configuration) && configuratorsDataService) {
                    this.Name = configuration.name;
                    this.Price = configuration.price;
                    this.PriceNoMargin = configuration.priceNoMargin;
                    this.PriceAfterDiscounts = configuration.priceAfterDiscounts;
                    this.PriceGross = configuration.priceGross;
                    this.PriceGrossAfterDiscounts = configuration.priceGrossAfterDiscounts;
                    this.Quantity = configuration.quantity;
                    this.PriceSegments = configuration.priceSegments;
                    this.PriceSegmentsNoMargin = configuration.priceSegmentsNoMargin;
                    this.PriceParts = configuration.priceParts;
                    this.PricePartsNoMargin = configuration.pricePartsNoMargin;
                    this.DiscountGroups = configuration.discountGroups;
                    this.DiscountGroupsNoMargin = configuration.discountGroupsNoMargin;
                    this.Title = configuration.title;
                    this.Description = configuration.description;
                    this.valid = configuration.valid;
                    this.attributes = configuration.attributes;

                    this.System = configuratorsDataService.get(
                        'mosquitoLines',
                        configuration.system.id
                    );
                    this.Height = configuration.height;
                    this.Width = configuration.width;
                    this.HeightModify = configuration.heightModify;
                    this.WidthModify = configuration.widthModify;
                    this.Shape = {
                        width: configuration.width,
                        height: configuration.height,
                        circuit: configuration.circuit,
                        sashWidth: configuration.sashWidth,
                        sashHeight: configuration.sashHeight
                    };
                    if (configuration.variant) {
                        this.Type = configuratorsDataService.get(
                            'mosquitoTypes',
                            String(configuration.system.id),
                            configuration.variant.id
                        );
                        if (configuration.variant.hasDirection) {
                            this.Direction = configuration.direction === 'L' ? 'left' : 'right';
                        }
                    }
                    if (configuration.netType) {
                        this.NetType = configuratorsDataService.get(
                            'mosquitoNetTypes',
                            configuration.netType.id
                        );
                    }
                    if (configuration.colors.frame && configuration.colors.frame.name) {
                        this.Colors.frame = this.configuratorsDataService.get(
                            'windowColorsAll',
                            configuration.colors.frame.id
                        );
                    }
                    if (configuration.colors.net && configuration.colors.net.name) {
                        this.Colors.net = {
                            code: configuration.colors.net.code,
                            name: configuration.colors.net.name,
                            color: configuration.colors.net.code === 'black' ? '000000' : 'A9A9A9',
                        };
                    }
                    if (configuration.colors.panel && configuration.colors.panel.name) {
                        this.Colors.panel = {
                            code: configuration.colors.panel.code,
                            name: configuration.colors.panel.name,
                            color:
                                configuration.colors.panel.code === 'white' ? 'FFFFFF' : '654321',
                        };
                    }

                    if (configuration.montage) {
                        this.Montage = configuratorsDataService.get(
                            'mosquitoMontages',
                            configuration.montage.id
                        );
                    }
                    if (configuration.windowLine) {
                        this.WindowLine = configuratorsDataService.get(
                            'mosquitoWindowLines',
                            String(configuration.system.id),
                            configuration.windowLine.id
                        );
                    }
                    ['up', 'down', 'left', 'right'].forEach(side => {
                        if (configuration.profilePositions[side]) {
                            this.ProfilePositions[side] = configuration.profilePositions[side];
                        }
                    });
                    this.HoldersWidth = configuration.holdersWidth;
                    this.MuntinType = configuration.muntinPosition.type;
                    if (configuration.muntinPosition.type === 'custom') {
                        this.MuntinPosition = configuration.muntinPosition.position;
                    }
                    this.hasThickSeal = configuration.hasThickSeal;
                    this.sealThickness = configuration.sealThickness;
                }
            }
        }
        this.configuratorsDataService = null;
    }
    type: 'mosquito' = 'mosquito';
    Name = '';
    Price = 0;
    PriceNoMargin = 0;
    PriceAfterDiscounts = 0;
    PriceGross = 0;
    PriceGrossAfterDiscounts = 0;
    Quantity = 1;
    Issues: any[] = [];
    PriceSegments: PriceSegment[] = [];
    PriceSegmentsNoMargin: PriceSegment[] = [];
    PriceParts: PricePart[] = [];
    PricePartsNoMargin: PricePart[] = [];
    DiscountGroups: DiscountGroups = {};
    DiscountGroupsNoMargin: DiscountGroups = {};
    Discount = 0;
    Title = '';
    Description = '';
    Attachments = [];
    valid: {} = {};
    PriceValid = false;
    drawData: any;

    System: any = {};
    Height = 1300;
    Width = 1300;
    HeightModify = 0;
    WidthModify = 0;
    Shape: any = {};
    Type: any = {};
    NetType: MosquitoNetType | null = null;
    Colors: {
        frame?: IccColor,
        net?: {
            code: string;
            name: string;
            color: string;
        },
        panel?: {
            code: string;
            name: string;
            color: string;
        },
    } = {};
    Direction: any = null;
    Montage: any = null;
    WindowLine: any = null;
    ProfilePositions: any = {};
    HoldersWidth: any = null;
    MuntinPosition: any = null;
    MuntinType: any = null;
    hasThickSeal = false;
    sealThickness: number | null = null;
    attributes: {
        id: string;
        name: string;
        value: string;
        valueId?: number;
    }[] = [];

    public static is(configuration): configuration is MosquitoActiveConfiguration {
        return configuration instanceof MosquitoActiveConfiguration || !configuration.$version;
    }
}

export type IMosquitoActiveConfiguration = Pick<
    MosquitoActiveConfiguration,
    keyof MosquitoActiveConfiguration
>;

